// extracted by mini-css-extract-plugin
export default {"sortingButton":"TableHeader_sortingButton__9HXum","status":"TableHeader_status__BhN2+","selection":"TableHeader_selection__bmfLo"};